import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { LetterBookBadgeDict } from 'util/assignment-badge-util';
import CompletedBadgeImage from 'assets/images/Completed_badge.png';
import NewBadgeImage from 'assets/images/New_badge.png';
import RewardsStar from 'assets/images/rewardsStar.png';
import { ASSIGNMENT_STATUSES, AssignmentWithCover } from '../types';
import { isCompletedStatus } from '../util';

const altT = (key) => translate('alt', key);

const optionalActivities = ['wet-dry-try', 'practice-book'];

type Props = {
  assignment: AssignmentWithCover;
  showLetterBookBadge?: boolean;
  status?: string;
  activityName?: string;
  style?: Record<any, any>;
};

const AssignmentStatusBadge: React.FC<Props> = ({
  assignment,
  showLetterBookBadge = false,
  status = ASSIGNMENT_STATUSES.INCOMPLETE,
  activityName,
  style = {},
}) => {
  const classes = styles({ top: showLetterBookBadge ? -40 : 40 });

  const getStatusBadge = () => {
    const isComplete = isCompletedStatus(status);

    if (activityName && optionalActivities.includes(activityName) && isComplete) {
      return <img src={RewardsStar} alt={altT('star')} style={{ marginTop: 15 }} />;
    }

    return (
      <img
        src={isComplete ? CompletedBadgeImage : NewBadgeImage}
        alt={isComplete ? altT('greenCheckMark') : altT('newAssignmentBadge')}
      />
    );
  };

  return (
    <div style={{ display: 'inline-block', ...style }}>
      {status !== ASSIGNMENT_STATUSES.INCOMPLETE && (
        <div className={classes.badge} style={{ display: 'inline-block' }}>
          {getStatusBadge()}
        </div>
      )}
      {showLetterBookBadge && <img src={LetterBookBadgeDict[assignment.cover.id]} />}
    </div>
  );
};

const styles = makeStyles(() => ({
  badge: {
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
}));

export default AssignmentStatusBadge;
